import { useEffect, useState } from 'react';
import { onCheckIns, readCheckIns, TimerCheckIns } from '@utils/timerCheckIns';

const NONE: TimerCheckIns = { answered: 0, kept: [] };

/** A session timer's check-ins (utils/timerCheckIns.ts), read again whenever the pill or the popup answers one. */
export const useTimerCheckIns = (plannedTaskId?: number): TimerCheckIns => {
  const [checkIns, setCheckIns] = useState<TimerCheckIns>(() => (plannedTaskId ? readCheckIns(plannedTaskId) : NONE));
  useEffect(() => {
    if (!plannedTaskId) {
      setCheckIns(NONE);
      return;
    }
    setCheckIns(readCheckIns(plannedTaskId));
    return onCheckIns(id => {
      if (id === plannedTaskId) setCheckIns(readCheckIns(plannedTaskId));
    });
  }, [plannedTaskId]);
  return checkIns;
};
